<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: wjx
 * @LastEditTime: 2019-04-10 13:58:01
 -->
<template>
  <div style="padding-top:0.1px;height:100%;over-flow:hidden;">
    <div class="fixTop" ref="topBox">
      <course-video
        :pic="detailObj.coverPic"
        :detail-obj="detailObj"
        :sc-type="scType"
        :categories-arr="categoriesArr"
      ></course-video>
      <div class="tabBox">
        <tabBtn
          :textList="['提问区', '课程介绍']"
          @button-tab-change="tabChange"
          :defaultIndex="dfIndex"
        ></tabBtn>
      </div>
    </div>
    <div
      class="hasPadding"
      v-show="dfIndex == 1"
      ref="introBox"
      style="overflow:scroll;"
    >
      <!-- <h5 class="title">{{detailObj.courseName}}</h5> -->
      <div class="signBox">
        <h5 class="title">{{ detailObj.courseName }}</h5>
        <p @click="signIn" class="signIn">
          <img
            src="https://cdn.yxvzb.com/newWechat/image/%E7%AD%BE%E5%88%B0@2x.png"
            alt=""
          />
          <span>{{ isSignIn ? '已签到' : '签到' }}</span>
        </p>
      </div>
      <course-docter-info
        :obj="detailObj"
        :lec-list="lectrueList"
      ></course-docter-info>
      <catalog :catalog-obj="catalogObj"></catalog>
      <course-sign
        :is-sign-in="isSignIn"
        :num="playCount"
        :is-living="false"
        :detailObj="detailObj"
      ></course-sign>
      <relation-zone
        :channel-obj="channelObj"
        v-if="channelObj"
      ></relation-zone>
      <pay-course v-if="payObj" :courseObj="payObj"></pay-course>
      <rec-course :course-list="recCourseList"></rec-course>
    </div>
    <div class="hasPadding" v-show="dfIndex == 0" ref="pinglunBox">
      <comment
        v-if="wxUserInfo.userDataStatus"
        @event-collection="eventCollection"
        @startSign="signIn"
        :isSignIn="isSignIn"
        :is-collection="isCollection"
        :qa-id="detailObj.id"
        :type="6"
        :name="detailObj.courseName"
        :editor="detailObj.editorName"
      ></comment>
      <!-- <comment v-if="userInfo.phone" @event-collection="eventCollection" :is-collection="isCollection" :qa-id="detailObj.qaId" type="6" :name="detailObj.courseName" :editor="detailObj.editor" :is-signon='isSignIn'></comment> -->
    </div>
  </div>
</template>
<script>
import CourseVideo from './components/CourseVideo.vue';
import CourseDocterInfo from '@/components/Course/CourseDocterInfo.vue';
import CourseSign from '@/components/Course/CourseSign.vue';
import Catalog from './components/Catalog.vue';
import RelationZone from '@/components/Course/RelationZone.vue';
import comment from '@/components/Comment3/index.vue';
import payCourse from '@/components/payCourse.vue';
import tabBtn from '@/components/ButtonTab.vue';
import recCourse from '@/components/recCourse.vue';
import { mapState } from 'vuex';
import { course, shareCallback, signIn, getChannelById } from '@/api/ajax.js';
//todo 限制了是否显示论评 模拟落地分享也
export default {
  name: '',

  data() {
    return {
      zone_name: '',
      detailObj: {},
      categoriesArr: [],
      isCollection: 0,
      isSignIn: 0,
      isSignUp: 0,
      catalogObj: [],
      channelObj: null,
      playCount: 0,
      userInfo: {},
      scType: 'wx', // sc type
      lectrueList: [],
      subjectIds: [],
      payObj: null, // 精品课
      noQue: true, // 是否有签到题  true 没有
      dfIndex: 1,
      restTime: 1,
      recCourseList: []
    };
  },
  methods: {
    signIn() {
      //签到方法
      let data = {
        courseId: this.$route.params.id
      };
      if (this.isSignIn) {
        this.$vux.toast.show({
          type: 'text',
          text: '您已签到',
          position: 'middle'
        });
      } else if (this.noQue) {
        this.$vux.toast.show({
          type: 'text',
          text: '当前课程还没有考题',
          position: 'middle',
          width: '6rem'
        });
      } else {
        if (this.restTime >= 60) {
          this.$router.push({
            name: 'signIn',
            params: {
              id: this.$route.params.id
            },
            query: {
              isLiving: 0
            }
          });
        } else {
          this.$vux.toast.show({
            type: 'text',
            text: '听课满一分钟才能签到',
            position: 'middle',
            width: '6rem'
          });
        }
      }
    },
    tabChange(val) {
      //切换tab
      this.dfIndex = val;
    },

    getLiveStatus() {
      course
        .isLiveing({
          courseId: this.$route.params.id
        })
        .then(res => {
          if (res.data.type == 2) {
            //直播中
            this.$router.push({
              name: 'liveDetail',
              params: {
                id: this.$route.params.id
              }
            });
          } else if (res.data.stauts == 'error') {
            //直播前  这个很奇怪
            this.$router.push({
              name: 'liveDetail',
              params: {
                id: this.$route.params.id
              }
            });
          }
        });
    },
    eventCollection(val) {
      this.isCollection = val;
    },
    toApp() {
      window.location =
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.yxvzb.app';
    },
    getDetail() {
      let isShequn = this.$route.query.shequn;
      let isShare = this.$route.query.shareFlag;
      let sourceFrom = this.$route.query.sourceFrom;
      let data = {
        id: this.$route.params.id,
        courseId: this.$route.params.id
      };
      // 获取签到题
      signIn.questions(data).then(res => {
        this.noQue = res.data.data.length ? false : true;
      });
      // 推荐课程 与精品课
      course.randomRecommend(data).then(res => {
        let resp = res.data.data;
        if (resp.jppxCourse) {
          this.payObj = resp.jppxCourse;
        }
        this.recCourseList = resp.courseList;
      });

      course.wxdetail(data).then(res => {
        //详情
        let resp = res.data.data;
        this.categoriesArr = this.$api.categoriesFilter(resp.categories);
        for (var item of this.categoriesArr) {
          if (item.categoryLevel == 1) {
            this.subjectIds.push(item.id);
          }
        }

        this.detailObj = resp;
        this.lectrueList = resp.lecturerList;
        this.isCollection = resp.isCollected;
        this.isSignIn = resp.isSignIn;

        this.playCount = resp.playCount;
        // 章节
        this.catalogObj = resp.chapters;
        //关联学院
        this.channelObj = resp.relationChannel;
        let customSA = {}; //神策自定义属性
        //社群 还是 分享 社群优先级高

        if (this.$route.query.shareFlag) {
          this.scType = 'share';
        }
        if (this.$route.query.shequn) {
          this.scType = 'shequn';
        }
        if (sourceFrom == 'yabao' && this.$route.query.source_user_id) {
          // 如果是亚宝分享出来的 增加分享着ID
          customSA.source_user_id = this.$route.query.source_user_id;
        }
        let SADATA = {
          ...{
            pageUrl: location.href,
            course_id: this.$route.params.id,
            course_name: this.detailObj.courseName,
            client_id: this.wxUserInfo.id || this.wxUserInfo.wxOpenId,
            course_type: 'video',
            editor: this.detailObj.editorName || '',
            from: this.scType,
            web_edition: 2
          },
          ...customSA
        };
        sa.track('course_detail', SADATA, function() {});

        /*
         * 分享
         * */
        let shareCallBackFunc = () => {
          shareCallback().then(res => {
            if (res.data.status == '1') {
              //恭喜您分享成功,获得3积分 每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '恭喜您获得3积分',
                type: 'success',
                width: '5rem'
              });
            } else {
              //您已获得今天全部分享 积分每天前5次分享均可获得3积分
              this.$vux.toast.show({
                text: '分享成功!',
                type: 'success',
                width: '5rem'
              });
            }

            sa.track(
              'share_total',
              {
                from: 'wx',
                type: 'video',
                target: this.$route.params.id,
                client_id: this.wxUserInfo.id || this.wxUserInfo.wxOpenId,
                web_edition: 2
              },
              function() {}
            );
            // 分享埋点
            this.$sa.re_interaction({
              type: '分享', // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
              contentype: 6, // 互动主体 直播，录播，资讯，病例，站内信，论坛
              contentid: this.$route.params.id, // 内容id
              first_cate: '', //一级分类
              second_cate: '', // 2级分类
              first_cate_id: '', // 1级分类id
              second_cate_id: '', //2级分类id
              author: this.detailObj.editorName || '', //讲师/作者
              contentname: this.detailObj.courseName,
              zone_name: this.$route.query.source_user_id
                ? ''
                : this.zone_name || '', // 来源专区
              zone_id: this.$route.query.source_user_id
                ? ''
                : this.$route.query.zone_id || '', // 来源专区
              source_user_id: this.$route.query.source_user_id || '' // 邀请人ID
              // location:'', //位置 站内，专区内，超级面对面内
            });
          });
        };
        /*
         * 格式化URL 如果带有社群flag 则清空query
         *
         * 如果没有shareFlag 则自动补齐
         * */
        let shareUrl = this.$api.infoWxShareUrl();
        if (isShequn) {
          shareUrl = shareUrl.split('?')[0];
        }
        if (!isShare) {
          // if (sourceFrom == 'yabao') {
          //     shareUrl = `${shareUrl}${this.$api.prefixQuery(shareUrl)}source_user_id=${wxUserInfoObj.id}&shareFlag=true`
          // } else {
          //     shareUrl = `${shareUrl}${this.$api.prefixQuery(shareUrl)}shareFlag=true`
          // }
          let { zone_id, source_user_id } = this.$route.query;
          if (zone_id && !source_user_id) {
            shareUrl = `${shareUrl}${this.$api.prefixQuery(
              shareUrl
            )}source_user_id=${this.wxUserInfo.shenceId}&shareFlag=true`;
          } else {
            shareUrl = `${shareUrl}${this.$api.prefixQuery(
              shareUrl
            )}shareFlag=true`;
          }
        }
        if (this.$route.query.zone_id) {
          getChannelById({
            channelId: this.$route.query.zone_id
          }).then(res => {
            this.zone_name = res.data.data;
            this.$wxShareInfo(
              this.detailObj.courseName,
              this.detailObj.courseName,
              this.detailObj.coverPic,
              location.href,
              shareUrl,
              shareCallBackFunc
            );
          });
        } else {
          this.$wxShareInfo(
            this.detailObj.courseName,
            this.detailObj.courseName,
            this.detailObj.coverPic,
            location.href,
            shareUrl,
            shareCallBackFunc
          );
        }
      });
    }
  },
  computed: {
    ...mapState({
      wxUserInfo: state => state.wxUserInfo
    })
  },
  components: {
    CourseVideo,
    CourseDocterInfo,
    CourseSign,
    Catalog,
    RelationZone,
    comment,
    payCourse,
    tabBtn,
    recCourse
  },
  watch: {
    $route: 'getDetail'
  },
  created() {
    // 判断当前课是否为直播 重构后没有提供
    // this.getLiveStatus()
    this.getDetail();
    let that = this;
    this.$nextTick(() => {
      // console.log(this.$refs.topBox)
    });

    clearInterval(countRest);
    let countRest = setInterval(() => {
      if (that.restTime > 60) {
        clearInterval(countRest);
      } else {
        that.restTime += 1;
      }
    }, 1000);
  },
  mounted() {
    // let allHeight = document.body.clientHeight/(document.body.clientWidth/10)
    // this.$refs.introBox.style.height = (allHeight-6.9)+'rem'
  }
};
</script>
<style lang="less" scoped>
@import '../../../public/style/g.less';
.fixTop {
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 2008;
  width: 100%;
  height: 6.8rem;
  background: #fff;
}

.hasPadding {
  // margin-top: 7.2rem;
}

.tabBox {
  width: 9.28rem;
  margin: auto;
  padding-top: 0.4rem;
  background: #fff;
}

.signBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.35rem;
  border-bottom: 1px solid #ebebeb;
  padding-top: 0.32rem;
  .title {
    font-size: 0.4266rem;
    // margin-top: 0.4rem;
    width: 7rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .signIn {
    img {
      width: 0.5rem;
      height: 0.5rem;
    }
    span {
      font-size: 0.24rem;
    }
  }
}

.course_footer {
  -webkit-box-sizing: border-box;
  position: relative;
  margin-top: 0.42rem;
  text-align: center;
  font-size: 0.4533rem;
  font-weight: bold;
  padding: 0 0.4rem;
  width: 100%;
  height: 2.9333rem;
  margin-bottom: 0.4rem;
  img {
    width: 100%;
    height: 2.9333rem;
    margin-bottom: 0.4rem;
  }
}
</style>
